import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import { ChapterProvider } from './hooks/useChapters';
import Navbar from './components/ui/Navbar';
import Footer from './components/ui/Footer';
import HomePage from './components/pages/HomePage';
import ChaptersPage from './components/pages/ChaptersPage';
import LoginPage from './components/auth/LoginPage';
import SignupPage from './components/auth/SignupPage';
import SubscriptionPage from './components/subscription/SubscriptionPage';
import AdminPage from './components/admin/AdminPage';
import SettingsPage from './components/pages/SettingsPage';
import PrivacyPolicy from './components/pages/PrivacyPolicy';
import TermsOfService from './components/pages/TermsOfService';
import ContactPage from './components/pages/ContactPage';
import HelpFAQ from './components/pages/HelpFAQ';
import ProtectedRoute from './components/ui/ProtectedRoute';
import './styles/App.css';
import './styles/components.css';
import './index.css';

function App() {
  return (
    <AuthProvider>
      <ChapterProvider>
        <Router>
          <div className="app">
            <Navbar />
            <main className="main-content">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/chapters" element={<ChaptersPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/signup" element={<SignupPage />} />
                <Route path="/subscription" element={<SubscriptionPage />} />
                <Route path="/settings" element={
                  <ProtectedRoute>
                    <SettingsPage />
                  </ProtectedRoute>
                } />
                <Route path="/admin" element={
                  <ProtectedRoute requireAdmin>
                    <AdminPage />
                  </ProtectedRoute>
                } />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/help" element={<HelpFAQ />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </ChapterProvider>
    </AuthProvider>
  );
}

export default App;
